var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmMeasurement = function SvgBmMeasurement(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17.2 18.397",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.84 -0.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 6.452,
    height: 17.197,
    transform: "translate(2.44 1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.886,14.876,20.663,18.7,17.44,14.876V1.5h6.446Z",
    transform: "translate(-5.446)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 3.185,
    transform: "translate(2.797 5.003)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 5.732,
    transform: "translate(12.351 5.003)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 5.732,
    transform: "translate(12.351 14.557)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 1.911,
    transform: "translate(2.797 7.551)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 3.185,
    transform: "translate(2.797 10.099)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 1.911,
    transform: "translate(2.797 12.646)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 3.185,
    transform: "translate(2.797 15.194)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 9.554,
    transform: "translate(15.217 5.003)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmMeasurement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_Measurement.6ccb7d1e.svg";
export { ForwardRef as ReactComponent };